module.exports = __webpack_public_path__ + "img/diagram_good.d421ea50.svg";